export const jobTypesCz = {
  jobTypes: {
    // Database keys (snake_case)
    'full_time': 'Plný úvazek',
    'part_time': 'Poloviční úvazek',
    'half_time': 'Poloviční úvazek',
    'freelance': 'Freelance',
    'internship': 'Stáž',
    'contract': 'Smluvní',
    'temporary': 'Dočasný',
    'seasonal': 'Sezónní',
    // Legacy display names (for backward compatibility)
    'Half Time': 'Poloviční úvazek',
    'Full Time': 'Plný úvazek',
    'Freelance': 'Freelance',
    'Internship': 'Stáž'
  }
};